import type { PropsWithChildren } from 'react';
import { cn } from '../../lib/utils.ts';

type Props = {
    up?: boolean | null;
    className?: string;
} & PropsWithChildren;

export function DeltaText({ up, children, className = '' }: Props) {
    return (
        <span
            className={cn(
                up === true && 'text-emerald-500',
                up === false && 'text-red-500',
                up === undefined || (up === null && 'text-neutral-500'),
                'flex items-center',
                className,
            )}
        >
            {children}
        </span>
    );
}
